import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
type SupabaseAdminClient = ReturnType<typeof createClient>;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase admin credentials not found');
}

const ADMIN_CLIENT_KEY = '__supabase_admin_singleton__';
let adminInstance: SupabaseAdminClient | null = null;

const createAdminClient = (): SupabaseAdminClient => {
  if (adminInstance) return adminInstance;

  if (typeof window !== 'undefined' && (window as any)[ADMIN_CLIENT_KEY]) {
    adminInstance = (window as any)[ADMIN_CLIENT_KEY] as SupabaseAdminClient;
    return adminInstance;
  }

  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (args[0]?.includes?.('Multiple GoTrueClient')) return;
    originalWarn.apply(console, args);
  };

  adminInstance = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
      storageKey: 'surdurulebilirlik-admin-auth',
    },
  });

  console.warn = originalWarn;

  if (typeof window !== 'undefined') {
    (window as any)[ADMIN_CLIENT_KEY] = adminInstance;
  }

  return adminInstance as SupabaseAdminClient;
};

export const supabaseAdmin = createAdminClient();
